<div class="row p-2 mb-3 align-items-center">
  <div class="col-12 col-md-7 text-start">
    <div class="page-title-heading">
      <div class="page-title-icon"><i class="fa-solid fa-user-graduate"></i></div>
      <div>
        Liste des élèves
        <div class="page-title-subheading">Élèves inscrits</div>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-5 text-end">
    <app-header></app-header>
  </div>
</div>
    <div class="card mb-3">
      <div class="card-body py-3">
        <div class="row g-3 align-items-end">
          <div class="col-12 col-md-4">
            <label for="ay_pick" class="form-label mb-0"><strong>Année académique</strong></label>
            <ng-select id="ay_pick" (change)="loadData1($event)" [clearable]="false" placeholder="Choisir l'année">
                <ng-option *ngFor="let ay of ays" [value]="ay.id">{{ay?.name}}</ng-option>
            </ng-select>
          </div>
          <div class="col-12 col-md-4">
            <label for="cl_pick" class="form-label mb-0"><strong>Classe</strong></label>
            <ng-select id="cl_pick" (change)="loadData2($event)" [clearable]="false" placeholder="Choisir la classe">
                <ng-option *ngFor="let classroom of classrooms" [value]="classroom.id">{{classroom?.name}}</ng-option>
            </ng-select>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
        <div class="col-lg-12">
            <div class="card">
                <div class="card-body">
                      <div class="d-flex justify-content-between mb-5">
                        <div class="me-2">
                            <button *ngIf="buttonsPermission?.add" type="button" class="btn btn-danger btn-sm" (click)="add(addContent)">
                                <i class="fa-solid fa-plus me-2" aria-hidden="true"></i>Nouvel élève
                            </button>
                        </div>
                        <div *ngIf="buttonsPermission && selected_data && role!='bvs'">
                            <button class="btn btn-outline-danger btn-sm" (click)="deleteStudent()"
                                    title="Retirer l'élève sélectionné de la classe">
                                <i class="fa-solid fa-user-minus me-1" aria-hidden="true"></i>Retirer l'apprenant
                            </button>
                        </div>

                        <div class="form-group ms-auto">
                            <label for=""> <strong>Rechercher:</strong> </label>
                            <input placeholder="Rechercher..." class="form-control form-control-sm" type="text" name="search_text" [(ngModel)]="search_text">
                        </div>
                    </div>
    
                            <p>{{data!.length}} élément(s)</p>
                            <div class="table-responsive">
                            <table class="table" >
                                <thead class="">
                                    <tr>
                                        <th style="width: 10px;">#</th>
                                        <th>Apprenant</th>
                                        <th>Librables</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr (click)="checked(d)" [class.table-active]="selected_data?.id === d.id" style="cursor: pointer;" *ngFor="let d of data | sampleSearch:search_text:'students' | paginate: {
                                    id:'ngxP1',
                                    itemsPerPage: pg.pageSize,
                                    currentPage: pg.p,
                                    totalItems: pg.total } ">
                                        <td>
                                            <div class="form-check mb-2">
                                                <input (click)="checked(d)" class="form-check-input" type="radio" [checked]="selected_data?.id === d.id" name="flexRadioDefault">
                                            
                                            </div>
                                        </td>
                                        <td><strong>{{d.student?.lastname}} </strong>{{d.student?.firstname}}</td>
                                        <td>
                                            <ul *ngFor="let t of d.tsacs">
                                                <li class="pointer" > <u (click)="getFile(t.filename)" class="mx-1">{{t.template?.title}}</u> <i  (click)="delete(t.id)" class="fa fa-times text-danger"></i> </li>
                                            </ul>
                                        </td>
                                    </tr>
                                
                                </tbody>
                            </table>
                            </div>
                            <pagination-controls 
                            id="ngxP1"
                            (pageChange)="getPage($event)"
                          [maxSize]="9"
                          [directionLinks]="true"
                          [autoHide]="true"
                          [responsive]="true"
                          [previousLabel]="'Précédent'"
                          [nextLabel]="'Suivant'"
                          [screenReaderPaginationLabel]="'Pagination'"
                          [screenReaderPageLabel]="'page'"
                          [screenReaderCurrentLabel]="'Vous êtes sur la page'">
                         </pagination-controls>
    
                </div><!-- end card -->
            </div>
            <!-- end col -->
        </div>
        <!-- end col -->
    </div>
    
    
    <ng-template #addContent let-c="close" let-d="dismiss">
        <form #addForm="ngForm" (ngSubmit)="store(addForm.value)">
        <div class="modal-header">
          <h6 class="modal-title" id="modal-basic-title">Générer un livrable pour l'apprenant</h6>
          <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
        </div>
        <div class="modal-body" >
            <div class="row mb-3" >
                <div class="form-group">
                    <label for="">Choisir le template</label>
                    <ng-select name="template_id" ngModel (change)="loadContent($event)">
                        <ng-option *ngFor="let t of templates" [value]="t.id">{{t.title}}</ng-option>
                    </ng-select>
                </div>
                <div class=" form-group col-12 mb-3">
                    <label for="">Contenu <span class="text-danger ml-2">(*)</span></label>
                    <angular-editor name="text" [placeholder]="'Saisir le contennu'" [(ngModel)]="text" required></angular-editor>
                </div>
           
            </div>
           
        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-outline-dark" [disabled]="addForm.invalid"  >Enregistrer <app-loading [isVisible]="loading"></app-loading></button>
        </div>
    </form>
      </ng-template>
    
      <ng-template #editContent let-c="close" let-d="dismiss">
        <form #editForm="ngForm" (ngSubmit)="update(editForm.value)">
        <div class="modal-header">
          <h6 class="modal-title" id="modal-basic-title">Modifier une demande de permission</h6>
          <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
        </div>
        <div class="modal-body" >
            <div class="row mb-3" >
          
                
             
            </div>
           
           
        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-outline-dark" [disabled]="editForm.invalid" >Sauvegarder <app-loading [isVisible]="loading"></app-loading></button>
        </div>
    </form>
      </ng-template>

    <ng-template #contentPDF let-offcanvas>
        <div class="offcanvas-header">
        
            <h4 class="offcanvas-title">Visualiseur de fichier</h4>
            <button id="closePDFBtn" type="button" class="btn-close" aria-label="Close" (click)="offcanvas.dismiss('Cross click')"></button>
        </div>
        <div class="offcanvas-body">
            <ngx-extended-pdf-viewer [src]="pdfSrc"
            style="width: 100%; height: 100%"
            ></ngx-extended-pdf-viewer>
        </div>
    </ng-template>
    